/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'archive': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M.1.698h13.806v2.589H.099V.698zM.961 4.15h12.081v9.492H.963V4.15zM9.592 7.6V5.875H4.413v1.726h5.177z" _fill="#A1A0A0" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/archive.js